var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-list-plus-icon lucide-list-plus",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12H3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9v6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12h-6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListPlus);
export default __webpack_public_path__ + "static/media/list_plus.42a5d58168e21e25a5f3b7a0a46184b7.svg";
export { ForwardRef as ReactComponent };